<template>
  <div>
    <b-dropdown 
      :variant="buttonVariant()"
      id="unread-notes-dropdown" 
      text="Notes" 
      size="sm">
      <template slot="button-content">
        Notes <b-badge variant="light">{{ totalNotes }}</b-badge>
      </template>
      <b-dropdown-item 
        @click="goToMessages(nt.HHID)"
        v-for="(nt, index) in unreadNotes" 
        :key="index">
        {{ nt.FamilyName }} ({{ nt.HHID }}) <b-badge variant="dark">{{ nt.NumNotes }}</b-badge>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { apiService } from '../_services'

export default {
  data() {
    return {
      timeout: null
    }
  },
  computed: {
    totalNotes() {
      let total = 0
      this.unreadNotes.forEach(element => {
        total = total + element.NumNotes
      })
      return total
    },
    ...mapState({
      unreadNotes: state => state.notes.unreadNotes
    }),
  },
  destroyed() {
    clearTimeout(this.timeout)
  },
  methods: {
    buttonVariant() {
      if (this.totalNotes) {
        return "primary"
      } else {
        return "secondary"
      }
    },
    ...mapActions('notes', {fetchNotes: 'fetchUnreadNotes'}),
    goToMessages(hhid) {
      this.$router.push({path: `/householdnotes/${hhid}`})
    },
    getMessages() {
      let vm = this
      this.fetchNotes()
      .then(() => {
        vm.timeout = setTimeout(() => { vm.getMessages() }, 60000)
      })
      .catch(() => {
        console.log('error fetching unread notes, stopping polling')
        // do not retry if failed, rather have the messages stall than have the 
        // browser making calls to the backend when it is logged out
        //setTimeout(() => { vm.getMessages() }, 60000)
      })
    },
    // getMessages_old() {
    //   let vm = this
    //   apiService.getUnreadNotes()
    //   .then((response) => {
    //     console.log({response})
    //     vm.unreadNotes = response.data
    //     setTimeout(() => { vm.getMessages() }, 6000)
    //   })
    //   .catch((err) => {
    //     console.log({response})
    //     setTimeout(() => { vm.getMessages() }, 6000)
    //   })
    // }
  },
  created() {
    this.getMessages()
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/UnreadMessagesDropdown.vue